<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";

// State
const plans = ref([]);
const loading = ref(false);
const serverErrors = ref([]);
const formStep = ref(1);

// Computed
const portalLink = computed(() => {
  return process.env.VUE_APP_PORTAL_LINK + "order-plan/create-account?plan_id=" + plans.value.id;
});

// Functions
const fetchData = async () => {
  axios
    .get(process.env.VUE_APP_SUPASMART_URL + "api/plans?site_id=" + process.env.VUE_APP_SITE_ID)
    .then((response) => {
      console.log(response.data);
      plans.value = response.data.data[0];
    })
    .catch((error) => {
      console.error(error);
      plans.value = { id: 1, name: "The Unlimited Plan", amount: "25", amount_offer: "20" };
    });
};

// Lifecycle
onMounted(() => {
  fetchData();
});
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="hero central">
          <div class="split">
            <div class="titles">
              <img src="/images/logo1.webp" alt="Grapefroot logo" width="235" height="61" />
              <h1>Joocy <span>SIMs</span> with Joocy <span>Benefits</span></h1>
            </div>
          </div>

          <div class="split">
            <div class="plans">
              <a :href="portalLink" class="plan invert">
                <img src="/images/sim-finity-black.webp" alt="Sim card" />
                <div class="name">{{ plans.name }}</div>
                <div class="prices">
                  <div class="wasPrice">
                    <span v-if="plans.amount">£{{ plans.amount }}</span>
                  </div>
                  <div class="price">£{{ plans.amount_offer }}</div>
                </div>
              </a>
            </div>
            <div class="plan-usps">
              <div class="border-highlight">
                <div class="icon">
                  <img src="/images/unlimited-icon.webp" alt="Unlimited Calls, Texts and Data Icon" width="38" hegiht="19" />
                </div>
                <div class="copy">
                  <p>Unlimited Calls, Texts and Data</p>
                </div>
              </div>
              <div class="border-highlight space">
                <div class="icon">
                  <img src="/images/fiveg-icon.webp" alt="Fast 5G as standard Icon" width="13" height="19" />
                </div>
                <div class="copy">
                  <p>Fast 5G as standard</p>
                </div>
              </div>
              <div class="border-highlight">
                <div class="icon">
                  <img src="/images/roaming-icon.webp" alt="Roam Free in 75 Worldwide Countries Icon" widfth="31" height="19"/>
                </div>
                <div class="copy">
                  <p>Roam Free in 75 Worldwide Countries</p>
                </div>
              </div>
              <div class="border-highlight space">
                <div class="icon">
                  <img src="/images/free-delivery-icon.webp" alt="Free Delivery Icon" width="19" height="19" />
                </div>
                <div class="copy">
                  <p>Free Delivery</p>
                </div>
              </div>
            </div>
            <a href="/plans" class="all-plans-link">View all plans ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hero {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  padding: 3rem 1rem 8rem;
  gap: 3rem;
  filter: drop-shadow(var(--box-shadow));

  @media (min-width: 640px) {
    padding: 4rem 0 2rem;
  }

  .titles {
    text-align: right;
    filter: drop-shadow(1px 2px 4px rgba(0, 0, 0, 0.5));
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 60px;

    @media (max-width: 640px) {
      text-align: center;
      width: 80%;
    }

    > img {
      width: 85%;
      max-width: 530px;
    }

    // h1 {
    //     font-size: 5rem;
    //     margin-bottom: 0;

    //     span {
    //         color: var(--banana);
    //     }
    // }

    h1 {
      font-size: 2rem;
      margin-top: 0;

      span {
        color: var(--banana);
      }

      @media (max-width: 640px) {
        font-size: 1.4rem;
      }
    }
  }

  .plans {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 1rem;

    > img {
      height: 10vw;
      max-height: 90px;
    }

    .plan {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      width: 100%;
      background: var(--black);
      border-radius: 100px;
      padding: 1rem 2rem;
      transition: all 0.2s;
      cursor: pointer;
      min-height: 34px;
      text-decoration: none;

      @media (max-width: 640px) {
        gap: 1rem;
      }

      &:after {
        content: "+";
        position: absolute;
        right: 1rem;
        font-weight: 600;
        font-size: 2rem;
        transition: all 0.2s;
      }

      > img {
        height: 80%;
        position: absolute;
        left: 1rem;
      }

      .name {
        font-weight: 500;
        font-size: 1.5rem;

        @media (max-width: 640px) {
          font-size: 1.5rem;
        }
      }

      .prices {
        display: flex;
        align-items: center;
        gap: 1rem;

        @media (max-width: 640px) {
          gap: 0.5rem;
        }

        .wasPrice {
          text-decoration: line-through;
          min-width: 28px;
          font-size: 1.2rem;

          @media (max-width: 780px) {
            min-width: auto;
            font-size: 1rem;
            position: absolute;
            top: 5px;
          }
        }

        .price {
          font-size: 3rem;
          font-weight: 800;
          color: var(--banana);

          @media (max-width: 640px) {
            font-size: 2rem;
          }
        }
      }

      &.invert {
        background: var(--banana);
        color: var(--black);

        .wasPrice {
          color: var(--brown);
        }

        .price {
          color: var(--black);
        }
      }

      &:hover {
        transform: scale(1.04);

        &:after {
          font-size: 2em;
        }

        // background-color: var(--white);

        // color: var(--black);

        // .wasPrice {
        //     color: var(--brown);
        // }

        // .price {
        //     color: var(--black)
        // }
      }
    }
  }

  .plan-usps {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    @media (max-width: 640px) {
      gap: 0.5rem;
      width: calc(100% - 4rem);
    }

    > * {
      // flex: 1 1 calc(50% - 4rem);
      min-width: 200px;
    }

    .border-highlight {
      padding: 0rem 1rem 0rem 0rem;
      min-height: 51px;

      @media (max-width: 840px) {
        min-height: 34px;
      }

      .icon {
        display: flex;

        @media (max-width: 840px) {
          height: 60%;
        }

        img {
          height: 100%;
        }
      }
    }
  }

  .all-plans-link {
    text-align: center;
    cursor: pointer;
    color: var(--primary);
    text-decoration: none;
    font-weight: 600;

    &:hover {
      color: var(--banana);
    }
  }
}

.hero.central {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .split {
    width: 100%;
    max-width: 800px;
    flex: unset;

    .plans {
      max-width: unset;

      .plan {
        justify-content: center;
        gap: 4rem;

        @media (max-width: 640px) {
          gap: 1rem;
        }

        .name {
          flex: none;
        }
      }
    }

    .plan-usps {
      gap: 0.5rem;

      .border-highlight {
        padding: 0rem 3rem 0rem 0rem;
        gap: 2rem;
        flex: 1 1 calc(50% - 4rem);

        .icon {
          height: 60%;

          img {
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
